// Sales operations, lead movement, imports, tele-sales, and source mapping copy.
// Keys omit outer whitespace; numbered interpolation placeholders are preserved.
export const operationsArabicTranslations: Record<string, string> = {
  "New Mapping contacts during period": "العملاء الجدد من الـMapping خلال الفترة",
  "Includes waiting contacts. Each phone is counted once at its first system entry.": "يشمل العملاء في الانتظار. كل رقم يتحسب مرة واحدة حسب أول دخوله للسيستم.",
  "Dates use Cairo time. Source and course refer to the first source.": "التواريخ بتوقيت القاهرة. المصدر والكورس حسب أول مصدر دخل منه العميل.",
  "Unique new contacts": "عملاء جدد بدون تكرار",
  "Intake month": "شهر دخول العملاء",
  "Intake from": "دخول العملاء من",
  "Intake to": "دخول العملاء إلى",
  "Show intake report": "عرض إحصاء العملاء",
  "Choose a valid date range.": "اختار فترة تواريخ صحيحة.",
  "Apply the dates to update the report.": "اضغط عرض إحصاء العملاء لتطبيق التواريخ الجديدة.",
  "Loading intake report": "جاري تحميل إحصاء العملاء",
  "Failed to load intake report": "تعذر تحميل إحصاء العملاء",
  "No new contacts during this period": "مفيش عملاء جدد خلال الفترة دي",
  "{0} rows have no identifiable phone mapping and are excluded. The total may be incomplete.": "في {0} صف مش متحدد لهم عمود رقم التليفون وتم استبعادهم. الإجمالي ممكن يكون غير مكتمل.",
  "Lead": "ليد",
  "Select {0}": "اختار {0}",
  "No activity yet": "لسه مفيش نشاط",
  "Salesperson": "موظف سيلز",
  "Paused": "متوقف مؤقتًا",
  "Routing": "توجيه الليدات",
  "Last Touch": "آخر تواصل",
  "By": "بواسطة",
  "Current stage": "المرحلة الحالية",
  "Interested": "مهتم",
  "Platform": "المنصة",
  "Job Title": "المسمى الوظيفي",
  "Result": "النتيجة",
  "Distribution is available to Sales Managers and General Managers.": "التوزيع متاح لمدير المبيعات والمدير العام.",
  "Distribution action": "عملية التوزيع",
  "Data Extraction": "استخراج البيانات",
  "Lead Pool": "مخزن الليدات",
  "Manual Transfer": "نقل يدوي",
  "Search leads": "ابحث في الليدات",
  "Name, phone or lead code": "الاسم أو التليفون أو كود الليد",
  "Campaigns": "الحملات",
  "Select courses": "اختار الكورسات",
  "From salespeople": "من موظفي السيلز",
  "Previous owner": "الموظف السابق",
  "All previous owners": "كل الموظفين السابقين",
  "Select stages": "اختار المراحل",
  "Show results": "اعرض النتائج",
  "Unable to load campaign courses.": "مش قادرين نحمّل كورسات الحملات.",
  "Unable to load data.": "مش قادرين نحمّل البيانات.",
  "eligible leads": "ليدات متاحة",
  "matching leads": "ليدات مطابقة",
  "Select the first": "اختار أول",
  "Number of leads": "عدد الليدات",
  "eligible results": "نتائج متاحة",
  "matching results": "نتائج مطابقة",
  "Eligibility unavailable for": "مش قادرين نحدد أهلية",
  "leads: stage entry not recorded.": "ليد: وقت الدخول للمرحلة مش مسجل.",
  "Loading leads…": "بنحمّل الليدات…",
  "No eligible leads": "مفيش ليدات متاحة",
  "Recipient": "الموظف المستلم",
  "Recipients": "الموظفون المستلمون",
  "Select one employee": "اختار موظف واحد",
  "Select one or more employees": "اختار موظف واحد أو أكتر",
  "Distribution method": "طريقة التوزيع",
  "Equal Distribution": "توزيع بالتساوي",
  "Custom Quantity Per Employee": "عدد محدد لكل موظف",
  "Select recipients to enter quantities.": "اختار الموظفين المستلمين علشان تدخل الأعداد.",
  "Employee #{0}": "الموظف رقم {0}",
  "Quantity for employee {0}": "العدد للموظف {0}",
  "Execution is disabled in the Phase 1 integration review": "التنفيذ متوقف أثناء مراجعة الربط في المرحلة الأولى",
  "Preview Withdrawal": "عاين السحب",
  "Preview Assignment": "عاين الإسناد",
  "Review Transfer": "راجع النقل",
  "Confirm {0} Leads": "أكد {0} ليد",
  "leads —": "ليد —",
  "Receiving stage:": "مرحلة الاستلام:",
  "Old Data": "داتا قديمة",
  "Without previous history and comments": "من غير السجل والتعليقات السابقة",
  "With previous history and comments": "بالسجل والتعليقات السابقة",
  "Movement reason": "سبب النقل",
  "Movement History": "سجل نقل الليدات",
  "Lead or operation reference": "مرجع الليد أو العملية",
  "All types": "كل الأنواع",
  "All results": "كل النتائج",
  "Operation date": "تاريخ العملية",
  "Operation date from": "تاريخ العملية من",
  "Operation date to": "تاريخ العملية إلى",
  "Unable to load movement history": "مش قادرين نحمّل سجل نقل الليدات",
  "Loading history…": "بنحمّل السجل…",
  "Operation": "العملية",
  "From → To": "من ← إلى",
  "Actor": "الموظف اللي نفّذ",
  "Movement": "نقل",
  "No movements yet": "لسه مفيش عمليات نقل",
  "Movement details": "تفاصيل النقل",
  "Unable to load movement details.": "مش قادرين نحمّل تفاصيل النقل.",
  "Rollback": "تراجع عن النقل",
  "Rollback reason for {0}": "سبب التراجع عن {0}",
  "Request Rollback for": "اطلب التراجع عن",
  "No recorded lead details": "مفيش تفاصيل مسجلة لليد",
  "Timeline": "تسلسل الأحداث",
  "Request / decision: Not recorded": "الطلب / القرار: مش مسجل",
  "· Movement ·": "· نقل ·",
  "movements": "عمليات نقل",
  "Unable to load Lead Movement": "مش قادرين نحمّل نقل الليدات",
  "Waiting summaries": "ملخصات الانتظار",
  "Refresh Overview": "حدّث النظرة العامة",
  "No recommendations": "مفيش اقتراحات",
  "Distribution by Employee": "التوزيع حسب الموظف",
  "Current Leads": "الليدات الحالية",
  "Assigned This Month": "المسندة الشهر ده",
  "No employee distribution data": "مفيش بيانات توزيع على الموظفين",
  "Smart Redistribution": "إعادة توزيع ذكية",
  "Refresh recommendations": "حدّث الاقتراحات",
  "Review workflow requires the approved backend contract": "المراجعة محتاجة عقد الربط المعتمد مع الباك إند",
  "Decision reason": "سبب القرار",
  "Approve transfer": "وافق على النقل",
  "Approve lead": "وافق على الليد",
  "Return for edit": "رجّع للتعديل",
  "Lead code": "كود الليد",
  "Requester": "صاحب الطلب",
  "Proposed recipient": "الموظف المستلم المقترح",
  "Request date": "تاريخ الطلب",
  "Select a request": "اختار طلب",
  "Transfer Requests": "طلبات النقل",
  "New Lead Requests": "طلبات ليدات جديدة",
  "Name, phone or code": "الاسم أو التليفون أو الكود",
  "Unable to load requests": "مش قادرين نحمّل الطلبات",
  "No matching requests": "مفيش طلبات مطابقة",
  "Request details": "تفاصيل الطلب",
  "Course": "الكورس",
  "All courses": "كل الكورسات",
  "Clear filters": "امسح الفلاتر",
  "Target": "المستهدف",
  "records": "سجل",
  "Search employee": "ابحث عن موظف",
  "Filters and search": "الفلاتر والبحث",
  "Unable to load recommendations": "مش قادرين نحمّل الاقتراحات",
  "Could not load saved movement settings": "مش قادرين نحمّل إعدادات النقل المحفوظة",
  "Loading recommendations…": "بنحمّل الاقتراحات…",
  "Loading saved movement settings…": "بنحمّل إعدادات النقل المحفوظة…",
  "After-hours routing": "التوجيه خارج مواعيد العمل",
  "Enabled · Worker checked recently": "مفعّل · خدمة التوزيع اتراجعت قريب",
  "Enabled · Waiting for worker heartbeat": "مفعّل · مستنيين إشارة من خدمة التوزيع",
  "Disabled": "متوقف",
  "Queue new leads outside working hours": "حط الليدات الجديدة في الانتظار خارج مواعيد العمل",
  "Opens": "يفتح",
  "After-hours opens": "بداية الفترة خارج مواعيد العمل",
  "Closes": "يقفل",
  "After-hours closes": "نهاية الفترة خارج مواعيد العمل",
  "Release checks each employee’s saved shift, course assignment and available capacity. Leads wait if no eligible employee is available.": "التوزيع بيراجع شيفت كل موظف والكورسات المسندة له والسعة المتاحة. الليدات بتفضل في الانتظار لو مفيش موظف مناسب متاح.",
  "Automatic WhatsApp acknowledgement": "رسالة تأكيد تلقائية على واتساب",
  "WhatsApp connection is not configured": "اتصال واتساب مش متظبط",
  "Acknowledgement message": "رسالة التأكيد",
  "Rule change reason": "سبب تغيير القاعدة",
  "Reason for this change": "سبب التغيير ده",
  "Save Rule": "احفظ القاعدة",
  "Movement Batch Audit": "مراجعة دفعات النقل",
  "Batch": "الدفعة",
  "· Executed by": "· نفّذها",
  "Requested": "المطلوب",
  "· Eligible": "· المتاح",
  "· Excluded": "· المستبعد",
  "Lead #": "الليد رقم",
  "lead": "ليد",
  "leads": "ليدات",
  "Recommendation review": "مراجعة الاقتراح",
  "Review Recommendation": "راجع الاقتراح",
  "Reference:": "المرجع:",
  "Affected leads": "الليدات المتأثرة",
  "Current owner": "الموظف الحالي",
  "Selection reason": "سبب الاختيار",
  "Daily intake": "الاستلام اليومي",
  "Excluded leads": "الليدات المستبعدة",
  "recipient_data_missing": "بيانات الموظف المستلم ناقصة",
  "The current backend does not support deferring recommendations": "الباك إند الحالي مش بيدعم تأجيل الاقتراحات",
  "Defer unavailable": "التأجيل مش متاح",
  "Confirm Assignment": "أكد الإسناد",
  "Total leads:": "إجمالي الليدات:",
  "Employee #": "الموظف رقم",
  "Upper Management Safety Override": "تجاوز الحماية للإدارة العليا",
  "Override is disabled.": "تجاوز الحماية متوقف.",
  "Override lead IDs": "أرقام الليدات لتجاوز الحماية",
  "Lead IDs, separated by commas": "أرقام الليدات، وافصل بينها بفواصل",
  "Override target employee": "الموظف المستهدف لتجاوز الحماية",
  "Target employee ID": "رقم الموظف المستهدف",
  "Override reason": "سبب تجاوز الحماية",
  "Preview Override": "عاين تجاوز الحماية",
  "Confirm Override": "أكد تجاوز الحماية",
  "Conversion Rate": "نسبة التحويل",
  "Contacted": "تم التواصل",
  "Previous history and comments": "السجل والتعليقات السابقة",
  "Mapping": "ربط الحقول",
  "Requests Approval": "الموافقة على الطلبات",
  "Lead Movement Center": "مركز نقل الليدات",
  "{0}–{1} of {2}": "{0}–{1} من {2}",
  "Customer": "العميل",
  "Clear all": "امسح الكل",
  "From Date": "من تاريخ",
  "To Date": "إلى تاريخ",
  "Full Name": "الاسم بالكامل",
  "Phone Number": "رقم التليفون",
  "Location": "المكان",
  "Interested Course": "الكورس المهتم بيه",
  "Save settings": "احفظ الإعدادات",
  "critical": "حرج",
  "Total:": "الإجمالي:",
  "selected": "محدد",
  "Data Export is available to Upper Management only.": "تصدير البيانات متاح للإدارة العليا بس.",
  "Data Export / Data Extraction": "تصدير / استخراج البيانات",
  "Download eligible CRM data without changing the Lead Owner, Stage, or original entry date.": "نزّل بيانات CRM المتاحة من غير تغيير موظف الليد أو مرحلته أو تاريخ دخوله الأصلي.",
  "Lead Movement": "نقل الليدات",
  "Data export rules": "قواعد تصدير البيانات",
  "CRM read-only export": "تصدير بيانات CRM للقراءة فقط",
  "Original Created / Imported Date only": "تاريخ الإنشاء / الاستيراد الأصلي بس",
  "Minimum lead age in days": "أقل عمر لليد بالأيام",
  "Export filters": "فلاتر التصدير",
  "Enter DD/MM/YYYY or YYYY-MM-DD. Dates refer to original creation/import only. Quick ranges end 60 days ago, using Cairo time.": "اكتب التاريخ بصيغة DD/MM/YYYY أو YYYY-MM-DD. التواريخ تخص الإنشاء / الاستيراد الأصلي بس. الفترات السريعة بتنتهي قبل 60 يوم، بتوقيت القاهرة.",
  "* Required": "* مطلوب",
  "All Stages": "كل المراحل",
  "Export From Date": "تاريخ بداية التصدير",
  "DD/MM/YYYY or YYYY-MM-DD": "DD/MM/YYYY أو YYYY-MM-DD",
  "Export To Date": "تاريخ نهاية التصدير",
  "Quick date filters": "فترات سريعة",
  "Quick Date Filters": "فترات سريعة",
  "Older than 60 days": "أقدم من 60 يوم",
  "Last 3 months": "آخر 3 شهور",
  "Last 6 months": "آخر 6 شهور",
  "Export rules applied automatically:": "قواعد التصدير بتتطبق تلقائيًا:",
  "Lead Age < 60 days": "عمر الليد أقل من 60 يوم",
  "Booked customers": "عملاء حجزوا",
  "Future Next Action": "إجراء قادم في المستقبل",
  "From Date must be on or before To Date.": "تاريخ البداية لازم يكون قبل تاريخ النهاية أو نفس اليوم.",
  "Enter a valid date as DD/MM/YYYY or YYYY-MM-DD.": "اكتب تاريخ صحيح بصيغة DD/MM/YYYY أو YYYY-MM-DD.",
  "Preview first. Only eligible leads at least 60 days old are included.": "اعمل معاينة الأول. التصدير بيشمل الليدات المتاحة اللي عمرها 60 يوم على الأقل بس.",
  "Calculating…": "بنحسب…",
  "Preview Export": "عاين التصدير",
  "Data export results": "نتائج تصدير البيانات",
  "Exportable data count": "عدد البيانات المتاحة للتصدير",
  "These numbers already include every exclusion rule and represent the exact CSV rows.": "الأرقام دي بتشمل كل قواعد الاستبعاد وبتوضح عدد صفوف CSV بالظبط.",
  "Downloading…": "بننزّل…",
  "Download CSV": "نزّل CSV",
  "Total Exportable Data": "إجمالي البيانات المتاحة للتصدير",
  "Lead Age ≥ 60 · Not booked · No future Next Action": "عمر الليد 60 يوم أو أكتر · ماحجزش · مفيش إجراء قادم في المستقبل",
  "Data by Course": "البيانات حسب الكورس",
  "No exportable Leads match the selected filters.": "مفيش ليدات متاحة للتصدير مطابقة للفلاتر.",
  "Exportable Leads": "الليدات المتاحة للتصدير",
  "Choose the mandatory date range and preview the export.": "اختار فترة التاريخ المطلوبة واعمل معاينة للتصدير.",
  "CSV columns: Lead ID, Customer Name, Phone, Email, Course, Current Stage, Current Owner, Original Created/Imported Date, Next Action Date, Data Sheet.": "أعمدة CSV: رقم الليد، اسم العميل، التليفون، الإيميل، الكورس، المرحلة الحالية، الموظف الحالي، تاريخ الإنشاء / الاستيراد الأصلي، تاريخ الإجراء القادم، شيت البيانات.",
  "Sheet uploaded successfully.": "الشيت اترفع بنجاح.",
  "Upload failed.": "رفع الملف فشل.",
  "General manager access only": "متاح للمدير العام بس",
  "This upload page is not available for sales manager accounts.": "صفحة الرفع دي مش متاحة لحسابات مدير المبيعات.",
  "GENERAL MANAGER IMPORT": "استيراد المدير العام",
  "Upload Leads": "ارفع ليدات",
  "Upload Excel or CSV lead sheets. The page stores the file and stops there.": "ارفع شيت ليدات Excel أو CSV. الصفحة بتحفظ الملف وبس.",
  "Upload Excel Sheet": "ارفع شيت Excel",
  "Drop one file here and wait for the upload confirmation.": "حط ملف واحد هنا واستنى تأكيد الرفع.",
  ".xlsx / .xls / .csv": ".xlsx / .xls / .csv",
  "rows uploaded successfully.": "صف اترفع بنجاح.",
  "Uploading sheet...": "بنرفع الشيت...",
  "Click or drag file to this area to upload": "اضغط أو اسحب الملف هنا علشان ترفعه",
  "Supported formats: .xlsx, .xls, .csv": "الصيغ المدعومة: .xlsx، .xls، .csv",
  "No Answer > 7 Days": "مفيش رد لأكتر من 7 أيام",
  "Never Opened 24h": "مااتفتحش خلال 24 ساعة",
  "Missed Follow-ups": "متابعات فائتة",
  "After-hours Queue": "انتظار خارج مواعيد العمل",
  "Recovery Queue": "قائمة الاسترجاع",
  "Overloaded Staff": "موظفون فوق طاقتهم",
  "Auto Rules": "قواعد تلقائية",
  "Queues": "قوائم الانتظار",
  "No matches": "مفيش نتائج مطابقة",
  "Clear selection": "امسح التحديد",
  "Eligible": "متاح",
  "Excluded": "مستبعد",
  "Final": "النهائي",
  "Safety exclusions: Hot, Payment Pending, Meeting Scheduled, Upcoming Follow-up, recent successful contact, manual lock, VIP, and in-progress batches stay excluded. Override is Upper Management only.": "استبعادات الحماية: الليدات الساخنة، وفي انتظار الدفع، والمواعيد المحددة، والمتابعات القادمة، والتواصل الناجح القريب، والقفل اليدوي، وVIP، ودفعات النقل الجاري تنفيذها بتفضل مستبعدة. تجاوز الحماية للإدارة العليا بس.",
  "Preview": "معاينة",
  "Lead movement execution flow": "خطوات تنفيذ نقل الليدات",
  "Select → Preview → Confirm": "اختار ← عاين ← أكد",
  "Every bulk move uses a preview first, then creates Movement History.": "أي نقل جماعي بيبدأ بمعاينة، وبعدها بيتسجل في سجل نقل الليدات.",
  "Movement safety guardrails": "ضوابط حماية نقل الليدات",
  "Safety exclusions enforced": "استبعادات الحماية مفعّلة",
  "Admin / Team Leader / Sales permissions": "صلاحيات الأدمن / التيم ليدر / السيلز",
  "Moved {0} lead(s). Hidden queue: {1}.": "تم نقل {0} ليد. قائمة الانتظار المخفية: {1}.",
  "Lead movement failed": "نقل الليدات فشل",
  "Moved {0} selected lead(s); {1} conflict(s).": "تم نقل {0} ليد محدد؛ فيه {1} تعارض.",
  "Selected lead transfer failed": "نقل الليدات المحددة فشل",
  "Reassigned {0} lead(s).": "تم إعادة إسناد {0} ليد.",
  "Manual transfer failed": "النقل اليدوي فشل",
  "Redistributed {0} lead(s).": "تم إعادة توزيع {0} ليد.",
  "Smart redistribution failed": "إعادة التوزيع الذكية فشلت",
  "Transfer approved": "تمت الموافقة على النقل",
  "Transfer rejected": "تم رفض النقل",
  "Decision failed": "حفظ القرار فشل",
  "Lead approved and added to the requester pipeline": "تمت الموافقة على الليد وإضافته لقائمة عمل صاحب الطلب",
  "Lead request rejected": "تم رفض طلب الليد",
  "Lead request returned for editing": "طلب الليد اترجّع للتعديل",
  "Lead request decision failed": "حفظ قرار طلب الليد فشل",
  "Rollback request for lead #{0} sent to Upper Management.": "طلب التراجع عن نقل الليد رقم {0} اتبعت للإدارة العليا.",
  "Rollback request failed": "إرسال طلب التراجع فشل",
  "Reason for this recommendation": "سبب الاقتراح ده",
  "Recommendation {0} saved for manager review.": "الاقتراح {0} اتحفظ لمراجعة المدير.",
  "Could not save recommendation": "مش قادرين نحفظ الاقتراح",
  "Select up to {0} leads per transfer.": "اختار لحد {0} ليد لكل عملية نقل.",
  "No Answer lead drilldown": "تفاصيل ليدات مفيش رد",
  "Exact-ID transfer": "نقل بأرقام الليدات المحددة",
  "No Answer leads": "ليدات مفيش رد",
  "See each customer and current owner, then preview only the rows you select.": "شوف كل عميل وموظفه الحالي، وبعدها عاين الصفوف اللي اخترتها بس.",
  "Close No Answer lead drilldown": "اقفل تفاصيل ليدات مفيش رد",
  "No Answer drilldown totals": "إجماليات ليدات مفيش رد",
  "matching": "مطابق",
  "eligible": "متاح",
  "excluded": "مستبعد",
  "selection slots remaining": "أماكن تحديد متبقية",
  "Could not load No Answer leads": "مش قادرين نحمّل ليدات مفيش رد",
  "No matching No Answer leads": "مفيش ليدات مفيش رد مطابقة",
  "Select all eligible leads on this page": "حدد كل الليدات المتاحة في الصفحة دي",
  "Age": "العمر",
  "Last outcome": "آخر نتيجة",
  "Eligibility": "الأهلية",
  "h": "س",
  "Load more leads": "حمّل ليدات أكتر",
  "Transfer selected leads to": "انقل الليدات المحددة إلى",
  "Loading active sales staff...": "بنحمّل موظفي السيلز النشطين...",
  "Choose active sales / agent": "اختار موظف سيلز / وكيل نشط",
  "Selected lead preview": "معاينة الليدات المحددة",
  "Selected lead transfer result": "نتيجة نقل الليدات المحددة",
  "Moved": "تم النقل",
  "Conflicts": "تعارضات",
  "Hidden queue": "قائمة الانتظار المخفية",
  "Preview selected leads": "عاين الليدات المحددة",
  "Confirm exact transfer": "أكد نقل الليدات المحددة",
  "Submit Recommendation": "قدّم الاقتراح",
  "Lead Movement Folders": "مجلدات نقل الليدات",
  "Needs Action: select a problem, preview the impact, then confirm or submit recommendation.": "محتاج إجراء: اختار مشكلة، وعاين تأثيرها، وبعدها أكد أو قدّم اقتراح.",
  "Problem": "المشكلة",
  "Recommended Action": "الإجراء المقترح",
  "Open {0}: {1} leads": "افتح {0}: {1} ليد",
  "Safety Rules": "قواعد الحماية",
  "Always ON: Hot / Payment Pending / Upcoming Follow-up": "مفعّلة دائمًا: ساخن / في انتظار الدفع / متابعة قادمة",
  "Created month": "شهر الإنشاء",
  "Maximum leads": "أقصى عدد ليدات",
  "Backend cap": "حد الباك إند",
  "Open the customer list to select exact leads and a target employee.": "افتح قائمة العملاء علشان تختار الليدات بالظبط والموظف المستهدف.",
  "Open the Requests tab to approve or reject transfer requests.": "افتح تبويب الطلبات علشان توافق أو ترفض طلبات النقل.",
  "Hidden New leads are released automatically when a salesperson has fewer than {0} visible New leads.": "الليدات الجديدة المخفية بتظهر تلقائيًا لما يبقى عند موظف السيلز أقل من {0} ليد جديد ظاهر.",
  "The drilldown shows customer, current owner, age, eligibility, and exclusions before any exact-ID transfer.": "التفاصيل بتعرض العميل والموظف الحالي وعمر الليد وأهليته وأسباب الاستبعاد قبل نقل الليدات المحددة.",
  "Run preview to see the movement impact.": "اعمل معاينة علشان تشوف تأثير النقل.",
  "Open selected leads": "افتح الليدات المحددة",
  "Open Requests": "افتح الطلبات",
  "Refresh Snapshot": "حدّث الملخص",
  "Preview Impact": "عاين التأثير",
  "Confirm Movement": "أكد النقل",
  "Safety Override is visible to Upper Management only and is not available for operational users here.": "تجاوز الحماية بيظهر للإدارة العليا بس ومش متاح لموظفي التشغيل هنا.",
  "Select current and new owner, preview eligible leads, then confirm transfer.": "اختار الموظف الحالي والجديد، وعاين الليدات المتاحة، وبعدها أكد النقل.",
  "Preview required": "المعاينة مطلوبة",
  "Loading employees...": "بنحمّل الموظفين...",
  "New owner": "الموظف الجديد",
  "Statuses": "الحالات",
  "Last activity from": "آخر نشاط من",
  "Last activity to": "آخر نشاط إلى",
  "Safety exclusions always on": "استبعادات الحماية مفعّلة دائمًا",
  "Hot, Payment Pending, Meeting Scheduled, Upcoming Follow-up, recent successful contact, VIP, manual lock, and in-progress batch leads stay excluded. Override is Upper Management only.": "الليدات الساخنة، وفي انتظار الدفع، والمواعيد المحددة، والمتابعات القادمة، والتواصل الناجح القريب، وVIP، والقفل اليدوي، ودفعات النقل الجاري تنفيذها بتفضل مستبعدة. تجاوز الحماية للإدارة العليا بس.",
  "Check Eligible Leads": "راجع الليدات المتاحة",
  "Confirm Transfer": "أكد النقل",
  "Transfer Preview": "معاينة النقل",
  "Target owner:": "الموظف المستهدف:",
  "Set filters and check eligible leads.": "اضبط الفلاتر وراجع الليدات المتاحة.",
  "Distribute leads": "وزّع الليدات",
  "Choose the leads and recipients, then review the result before moving anything.": "اختار الليدات والموظفين المستلمين، وبعدها راجع النتيجة قبل النقل.",
  "Any campaign": "أي حملة",
  "Any course": "أي كورس",
  "Current pipeline status": "الحالة الحالية في قائمة العمل",
  "Any status": "أي حالة",
  "Target Salespeople": "موظفو السيلز المستهدفون",
  "Available Staff": "الموظفون المتاحون",
  "Distribution Method": "طريقة التوزيع",
  "Round Robin": "بالتناوب",
  "Random rotation": "تناوب عشوائي",
  "Maximum Leads": "أقصى عدد ليدات",
  "More criteria": "شروط إضافية",
  "Lead condition": "حالة الليد",
  "All matching leads": "كل الليدات المطابقة",
  "Protected leads are excluded automatically.": "الليدات المحمية بتُستبعد تلقائيًا.",
  "Preview Distribution": "عاين التوزيع",
  "Confirm Redistribute": "أكد إعادة التوزيع",
  "Distribution Preview": "معاينة التوزيع",
  "Preview distribution before confirming.": "عاين التوزيع قبل التأكيد.",
  "Current lead distribution": "توزيع الليدات الحالي",
  "Who has the leads now": "الليدات مع مين دلوقتي",
  "unassigned": "من غير موظف",
  "Show top 5": "اعرض أول 5",
  "View all {0} owners": "اعرض كل الـ {0} موظف",
  "Current leads": "الليدات الحالية",
  "Assigned this month": "المسندة الشهر ده",
  "No assigned leads in this scope.": "مفيش ليدات مسندة في النطاق ده.",
  "Current owner totals are unavailable from the connected API.": "إجماليات الموظفين الحاليين مش متاحة من API المتصل.",
  "Transfer Requests Approval": "الموافقة على طلبات النقل",
  "Pending until admin approval. The client stays with the current owner until a decision is saved.": "مستني موافقة الأدمن. العميل بيفضل مع موظفه الحالي لحد حفظ القرار.",
  "No transfer requests": "مفيش طلبات نقل",
  "Requested by": "صاحب الطلب",
  "Preferred target": "الموظف المفضل",
  "Pending until admin approval": "مستني موافقة الأدمن",
  "Target employee": "الموظف المستهدف",
  "Admin / Manager Decision Note": "ملاحظة قرار الأدمن / المدير",
  "Required when rejecting. Saved in Transfer Request History.": "مطلوبة عند الرفض. بتتحفظ في سجل طلبات النقل.",
  "Reject Request": "ارفض الطلب",
  "Approve Transfer": "وافق على النقل",
  "Change Target & Approve": "غيّر الموظف المستهدف ووافق",
  "Decision:": "القرار:",
  "New Lead Requests Approval": "الموافقة على طلبات ليدات جديدة",
  "Review employee submissions before they become active pipeline Leads.": "راجع الليدات اللي الموظفين قدموها قبل ما تدخل قائمة العمل.",
  "Returned for Edit": "اترجّع للتعديل",
  "No new Lead requests": "مفيش طلبات ليدات جديدة",
  "Select a new Lead request": "اختار طلب ليد جديد",
  "Manager Decision Note": "ملاحظة قرار المدير",
  "Required for Reject and Return for Edit": "مطلوبة عند الرفض أو الإرجاع للتعديل",
  "Return for Edit": "رجّع للتعديل",
  "Approve Lead": "وافق على الليد",
  "After-hours Auto Distribution": "توزيع تلقائي خارج مواعيد العمل",
  "Never Opened After 24h": "مااتفتحش بعد 24 ساعة",
  "No Answer After 7 Days": "مفيش رد بعد 7 أيام",
  "Safety Exclusions": "استبعادات الحماية",
  "Sales Manager / Team Leader / Sales": "مدير المبيعات / التيم ليدر / السيلز",
  "Visible New Queue": "قائمة الليدات الجديدة الظاهرة",
  "Transfer Approval": "الموافقة على النقل",
  "Active guardrails for movement, queue safety, and role permissions.": "ضوابط مفعّلة للنقل وحماية قوائم الانتظار وصلاحيات الأدوار.",
  "Edit the saved rule below": "عدّل القاعدة المحفوظة تحت",
  "Read only": "للقراءة فقط",
  "Configured below": "متظبط تحت",
  "Policy": "السياسة",
  "Queue Center": "مركز قوائم الانتظار",
  "Separate after-hours leads, recovery work, and capacity overflow without manual export.": "افصل ليدات خارج مواعيد العمل وليدات الاسترجاع والزيادة عن السعة من غير تصدير يدوي.",
  "Enters When": "يدخل لما",
  "Open Smart Redistribution": "افتح إعادة التوزيع الذكية",
  "View Auto Rule": "اعرض القاعدة التلقائية",
  "After-hours": "خارج مواعيد العمل",
  "Release depends on the saved rule, worker, employee shifts and capacity. See Auto Rules for current status.": "التوزيع بيعتمد على القاعدة المحفوظة وخدمة التوزيع وشيفتات الموظفين والسعة. راجع القواعد التلقائية للحالة الحالية.",
  "No fixed Recovery Team in the first version. Manager chooses rules or targets.": "مفيش فريق استرجاع ثابت في أول نسخة. المدير بيختار القواعد أو الموظفين المستهدفين.",
  "Auto WhatsApp": "واتساب تلقائي",
  "Available only when enabled in the saved rule and connected to CoreFlow.": "متاح بس لما يتفعّل في القاعدة المحفوظة ويتصل بـ CoreFlow.",
  "Safety": "الحماية",
  "Always ON. Override is Upper Management only.": "مفعّلة دائمًا. تجاوز الحماية للإدارة العليا بس.",
  "Latest assignment and transfer-request audit records.": "آخر سجلات الإسناد وطلبات النقل.",
  "Rollback becomes an Upper Management approval request before execution.": "التراجع بيتحوّل لطلب موافقة الإدارة العليا قبل التنفيذ.",
  "No movement history": "مفيش سجل نقل",
  "Visible/New": "ظاهر / جديد",
  "Rollback used": "تم استخدام التراجع",
  "Pending Upper Management Approval": "مستني موافقة الإدارة العليا",
  "Movement #": "النقل رقم",
  "· Lead #": "· الليد رقم",
  "From:": "من:",
  "→ To:": "← إلى:",
  "Executed by:": "نفّذها:",
  "· Reason:": "· السبب:",
  "Rule / Request:": "القاعدة / الطلب:",
  "· Requested:": "· المطلوب:",
  "· Eligible:": "· المتاح:",
  "· Excluded:": "· المستبعد:",
  "· Rollback:": "· التراجع:",
  "Rollback requested by:": "طلب التراجع:",
  "· Approved by:": "· وافق عليه:",
  "Excluded lead #": "الليد المستبعد رقم",
  "to": "إلى",
  "Pending Approval": "مستني الموافقة",
  "Request Rollback": "اطلب التراجع",
  "Lead Movement Center is available to Sales Manager, Team Leader, and Upper Management roles only.": "مركز نقل الليدات متاح لمدير المبيعات والتيم ليدر والإدارة العليا بس.",
  "CRM / Sales Management": "CRM / إدارة المبيعات",
  "Simple operational center for moving, redistributing, and reviewing leads safely.": "مركز تشغيل بسيط لنقل الليدات وإعادة توزيعها ومراجعتها بأمان.",
  "Movement Center Live": "مركز النقل شغال",
  "Movement summary": "ملخص النقل",
  "Movement center tabs": "تبويبات مركز النقل",
  "Failed to load movement center": "مش قادرين نحمّل مركز النقل",
  "Lead Pool is available to Sales Managers and Upper Management only.": "مخزن الليدات متاح لمدير المبيعات والإدارة العليا بس.",
  "Withdraw leads from an employee, then distribute them manually while preserving their data and history.": "اسحب الليدات من موظف، وبعدها وزّعها يدويًا مع الاحتفاظ ببياناتها وسجلها.",
  "Withdrawal changes assignment • Downloading a file does not withdraw the lead": "السحب بيغيّر الإسناد • تنزيل الملف مش بيسحب الليد",
  "Lead Pool sections": "أقسام مخزن الليدات",
  "Choose an employee, then select leads or withdraw all their leads at any time, with no 60-day minimum.": "اختار موظف، وبعدها حدد ليدات أو اسحب كل ليداته في أي وقت، من غير شرط 60 يوم.",
  "These leads have no current employee. Automatic distribution will not assign them before you distribute them manually.": "الليدات دي من غير موظف حالي. التوزيع التلقائي مش هيسندها قبل ما توزّعها يدويًا.",
  "Who withdrew each lead, its previous and new employees, and the time and reason for every operation.": "مين سحب الليد، ومن مين اتسحب، ولمين اتوزّع، ووقت وسبب كل عملية.",
  "Refresh": "حدّث",
  "Sales employee": "موظف السيلز",
  "Choose an employee": "اختار موظف",
  "(Inactive)": "(غير نشط)",
  "Name, phone, or lead ID": "الاسم أو التليفون أو رقم الليد",
  "Withdraw all employee leads": "اسحب كل ليدات الموظف",
  "Includes all the employee's leads across every page, beyond search results. The final count appears in the preview.": "بيشمل كل ليدات الموظف في كل الصفحات، مش نتائج البحث بس. العدد النهائي بيظهر في المعاينة.",
  "Could not load employees.": "مش قادرين نحمّل الموظفين.",
  "Could not load the list": "مش قادرين نحمّل القائمة",
  "Choose an employee to view their leads.": "اختار الموظف علشان تشوف ليداته.",
  "Withdrawal": "السحب",
  "Withdrawal reason": "سبب السحب",
  "Distribution": "التوزيع",
  "Distribution reason": "سبب التوزيع",
  "Available for distribution": "متاح للتوزيع",
  "Distributed": "تم التوزيع",
  "By:": "بواسطة:",
  "To:": "إلى:",
  "No withdrawals or distributions yet.": "لسه مفيش عمليات سحب أو توزيع.",
  "No matching leads.": "مفيش ليدات مطابقة.",
  "Select current page": "حدد الصفحة الحالية",
  "Phone": "التليفون",
  "Next follow-up": "المتابعة القادمة",
  "Select lead {0}": "حدد الليد {0}",
  "0 leads": "0 ليد",
  "Withdraw to pool": "اسحب للمخزن",
  "Distribute selected leads": "وزّع الليدات المحددة",
  "All employee leads": "كل ليدات الموظف",
  "{0} leads selected across pages": "{0} ليد محدد عبر الصفحات",
  "Receiving employees": "الموظفون المستلمون",
  "Choose one or more employees. Leads are distributed equally in turn.": "اختار موظف واحد أو أكتر. الليدات بتتوزّع بالتساوي بالتناوب.",
  "Distribute to {0}": "وزّع إلى {0}",
  "No Sales employees are available to receive leads.": "مفيش موظفين سيلز متاحين لاستلام الليدات.",
  "The lead ID, notes, contact history, booking, payment, and invoice data stay unchanged.": "رقم الليد وملاحظاته وسجل التواصل وبيانات الحجز والدفع والفواتير بيفضلوا زي ما هم.",
  "Processing…": "بننفّذ…",
  "Confirm lead withdrawal": "أكد سحب الليدات",
  "Confirm lead distribution": "أكد توزيع الليدات",
  "{0} leads will be withdrawn": "هيتم سحب {0} ليد",
  "{0} leads will be distributed": "هيتم توزيع {0} ليد",
  "They will leave the employee's work list and follow-ups and become available in the pool.": "هتختفي من قائمة عمل الموظف ومتابعاته وتبقى متاحة في المخزن.",
  "They will leave the available list and appear for the new employees.": "هتخرج من قائمة المتاح وتظهر عند الموظفين الجدد.",
  "Operation reason": "سبب العملية",
  "Enter the reason for withdrawal or distribution": "اكتب سبب السحب أو التوزيع",
  "Confirm withdrawal": "أكد السحب",
  "Confirm distribution": "أكد التوزيع",
  "External Upload": "رفع خارجي",
  "Lead Pool is available to sales managers only.": "مخزن الليدات متاح لمديري المبيعات بس.",
  "Legacy export archive": "أرشيف التصدير القديم",
  "Previous export records are saved for reference. They are unavailable for distribution, and their current employee stays unchanged.": "سجلات التصدير القديمة محفوظة للرجوع لها. مش متاحة للتوزيع، وموظفها الحالي بيفضل زي ما هو.",
  "Data Extraction + External Upload": "استخراج البيانات + رفع خارجي",
  "Lead Pool summary": "ملخص مخزن الليدات",
  "Total Leads in Pool": "إجمالي الليدات في المخزن",
  "Matching Leads": "الليدات المطابقة",
  "Stored Snapshot": "نسخة بيانات محفوظة",
  "Read-only": "للقراءة فقط",
  "Lead Pool filters": "فلاتر مخزن الليدات",
  "Search and filters": "البحث والفلاتر",
  "These filters search only data already collected in the Lead Pool.": "الفلاتر دي بتبحث في البيانات الموجودة في مخزن الليدات بس.",
  "Lead Pool Search": "البحث في مخزن الليدات",
  "Customer name, phone, email, or course...": "اسم العميل أو التليفون أو الإيميل أو الكورس...",
  "All Sources": "كل المصادر",
  "Original Created / Imported From": "الإنشاء / الاستيراد الأصلي من",
  "Lead Pool From Date": "تاريخ بداية مخزن الليدات",
  "Original Created / Imported To": "الإنشاء / الاستيراد الأصلي إلى",
  "Lead Pool To Date": "تاريخ نهاية مخزن الليدات",
  "Lead Pool data": "بيانات مخزن الليدات",
  "Collected data": "البيانات المجمّعة",
  "These are historical export snapshots, not available leads. Use explicit withdrawal to change ownership.": "دي نسخ محفوظة من تصديرات سابقة، مش ليدات متاحة. استخدم السحب الصريح علشان تغيّر الموظف.",
  "Lead Pool data by course": "بيانات مخزن الليدات حسب الكورس",
  "Could not load the Lead Pool": "مش قادرين نحمّل مخزن الليدات",
  "Loading collected data…": "بنحمّل البيانات المجمّعة…",
  "No Leads match the selected filters.": "مفيش ليدات مطابقة للفلاتر.",
  "Customer Name": "اسم العميل",
  "Original Created/Imported Date": "تاريخ الإنشاء / الاستيراد الأصلي",
  "Added to Lead Pool Date": "تاريخ الإضافة لمخزن الليدات",
  "Unspecified": "مش محدد",
  "Previous Lead Pool page": "الصفحة السابقة من مخزن الليدات",
  "Previous": "السابق",
  "Next Lead Pool page": "الصفحة التالية من مخزن الليدات",
  "Next": "التالي",
  "Rotation": "تدوير الليدات",
  "Choose your data, select the receiving salespeople, and rotate in a few steps.": "اختار بياناتك وموظفي السيلز المستلمين، ودوّر الليدات في خطوات بسيطة.",
  "Could not load salespeople.": "مش قادرين نحمّل موظفي السيلز.",
  "Could not load data sheets.": "مش قادرين نحمّل شيتات البيانات.",
  "Retry sheets": "حاول تحميل الشيتات تاني",
  "Rotation setup": "إعداد تدوير الليدات",
  "Choose data": "اختار البيانات",
  "Filters are optional. Each selection narrows the leads to rotate.": "الفلاتر اختيارية. كل اختيار بيحدد الليدات اللي هتتدوّر أكتر.",
  "Data sheet": "شيت البيانات",
  "Loading sheets…": "بنحمّل الشيتات…",
  "All sheets": "كل الشيتات",
  "Only sheets related to the selected course are shown.": "بيظهر بس الشيتات المرتبطة بالكورس المختار.",
  "Data Management source, combined with the course filter.": "مصدر إدارة البيانات مع فلتر الكورس.",
  "Uses the lead Created / Imported Date.": "بيستخدم تاريخ إنشاء / استيراد الليد.",
  "Calls and actions do not affect this range.": "المكالمات والإجراءات مش بتغيّر الفترة دي.",
  "All visible owners": "كل الموظفين الظاهرين",
  "All current stages": "كل المراحل الحالية",
  "Choose one or more current stages. Empty means all stages.": "اختار مرحلة حالية واحدة أو أكتر. من غير اختيار يعني كل المراحل.",
  "Up to 500 leads per rotation.": "لحد 500 ليد في كل تدوير.",
  "History mode": "طريقة التعامل مع السجل",
  "Keep history": "احتفظ بالسجل",
  "Fresh": "بداية جديدة",
  "Choose recipients": "اختار المستلمين",
  "Leads are distributed in turn across the selected salespeople.": "الليدات بتتوزّع بالتناوب على موظفي السيلز المختارين.",
  "Search recipients": "ابحث عن مستلمين",
  "Search salespeople…": "ابحث عن موظفي سيلز…",
  "Receiving salespeople": "موظفو السيلز المستلمون",
  "Loading salespeople…": "بنحمّل موظفي السيلز…",
  "No matching active salespeople.": "مفيش موظفي سيلز نشطين مطابقين.",
  "Fresh resets the receiving salesperson’s work cycle, while the original entry date stays unchanged. Leads 45 days old or newer enter New Data; older leads enter Old Data. Leads with unresolved demos are skipped.": "البداية الجديدة بتعيد دورة عمل الموظف المستلم، وتاريخ الدخول الأصلي بيفضل زي ما هو. الليدات اللي عمرها 45 يوم أو أقل بتدخل الداتا الجديدة، والأقدم بتدخل الداتا القديمة. الليدات اللي عندها ديمو لسه مااتحسمش بتُستبعد.",
  "The original Created / Imported Date controls the queue after rotation: 45 days old or newer enter New Data, while older leads enter Old Data. Calls and actions do not reset this age.": "تاريخ الإنشاء / الاستيراد الأصلي بيحدد القائمة بعد التدوير: الليدات اللي عمرها 45 يوم أو أقل بتدخل الداتا الجديدة، والأقدم بتدخل الداتا القديمة. المكالمات والإجراءات مش بتعيد حساب العمر ده.",
  "Checking leads…": "بنراجع الليدات…",
  "Preview rotation": "عاين التدوير",
  "Rotation preview": "معاينة التدوير",
  "Ready to rotate": "جاهزة للتدوير",
  "skipped leads": "ليدات متخطّاة",
  "selected salespeople": "موظفو سيلز محددون",
  "Expected distribution": "التوزيع المتوقع",
  "Each Lead excludes its current owner. Availability is checked again when you confirm.": "كل ليد بيستبعد موظفه الحالي. التوفر بيتراجع تاني لما تأكد.",
  "Confirm rotation": "أكد التدوير",
  "Rotating leads…": "بندوّر الليدات…",
  "leads rotated": "ليد اتدوّر",
  "waiting for pipeline capacity. Movement history has been updated.": "مستني سعة في قائمة العمل. سجل النقل اتحدّث.",
  "Rotation is available to sales managers only.": "تدوير الليدات متاح لمديري المبيعات بس.",
  "Numbers distributed to Tele Sales.": "الأرقام اتوزّعت على التلي سيلز.",
  "Could not distribute numbers": "مش قادرين نوزّع الأرقام",
  "{0} qualified leads sent to Sales.": "تم إرسال {0} ليد مؤهل للسيلز.",
  "Could not send qualified leads to Sales": "مش قادرين نبعت الليدات المؤهلة للسيلز",
  "Received": "تم الاستلام",
  "Original Interest": "الاهتمام الأصلي",
  "Numbers": "الأرقام",
  "Distributed:": "الموزّع:",
  "Remaining:": "المتبقي:",
  "View Leads": "اعرض الليدات",
  "Distribute": "وزّع",
  "Lead #{0}": "الليد رقم {0}",
  "Current Interest": "الاهتمام الحالي",
  "Changed": "اتغيّر",
  "Call Status": "حالة المكالمة",
  "Qualification": "التأهيل",
  "Tele Sales Employee": "موظف التلي سيلز",
  "Assigned Today": "المسند النهارده",
  "Total Assigned": "إجمالي المسند",
  "Not Interested": "مش مهتم",
  "Qualified": "مؤهل",
  "Sales Manager Workspace": "مساحة عمل مدير المبيعات",
  "Tele Sales Management": "إدارة التلي سيلز",
  "Receive batches from upper management, distribute a controlled number of phone numbers to Active Tele Sales Employees, monitor Today Numbers, and route Qualified Leads to Sales in bulk by Current Interest.": "استلم دفعات من الإدارة العليا، ووزّع عدد محدد من أرقام التليفونات على موظفي التلي سيلز النشطين، وتابع أرقام النهارده، وابعث الليدات المؤهلة للسيلز جماعيًا حسب الاهتمام الحالي.",
  "Distribute Numbers": "وزّع الأرقام",
  "Bulk Send To Sales": "إرسال جماعي للسيلز",
  "Could not load Tele Sales Management": "مش قادرين نحمّل إدارة التلي سيلز",
  "Received Batches": "الدفعات المستلمة",
  "Lead Distribution": "توزيع الليدات",
  "Today Numbers": "أرقام النهارده",
  "Qualified Leads": "الليدات المؤهلة",
  "Received Numbers": "الأرقام المستلمة",
  "From upper management": "من الإدارة العليا",
  "Assigned to Tele Sales": "مسند للتلي سيلز",
  "Ready to distribute": "جاهز للتوزيع",
  "Waiting for bulk Sales handoff": "مستني التسليم الجماعي للسيلز",
  "Search batch, source, sheet...": "ابحث عن دفعة أو مصدر أو شيت...",
  "Batch Status": "حالة الدفعة",
  "Remaining only": "المتبقي بس",
  "No received batches": "مفيش دفعات مستلمة",
  "Active Tele Sales Employees": "موظفو التلي سيلز النشطون",
  "No active Tele Sales employees": "مفيش موظفين تلي سيلز نشطين",
  "Select a Current Interest group, or select multiple qualified leads with the same Current Interest.": "اختار مجموعة اهتمام حالي، أو اختار كذا ليد مؤهل بنفس الاهتمام الحالي.",
  "Bulk Send Selected": "ابعث المحدد جماعيًا",
  "Selected qualified leads must share one Current Interest before bulk handoff.": "الليدات المؤهلة المحددة لازم تكون بنفس الاهتمام الحالي قبل التسليم الجماعي.",
  "No Current Interest groups are waiting for Sales handoff.": "مفيش مجموعات اهتمام حالي مستنية التسليم للسيلز.",
  "No Qualified Leads waiting for Sales": "مفيش ليدات مؤهلة مستنية السيلز",
  "Received Batch": "الدفعة المستلمة",
  "Select batch": "اختار دفعة",
  "Select Tele Sales employee": "اختار موظف تلي سيلز",
  "Number of Leads": "عدد الليدات",
  "Read Only: manager view cannot edit Call Status, Current Interest, or Qualification Status.": "للقراءة فقط: المدير مش بيقدر يعدّل حالة المكالمة أو الاهتمام الحالي أو حالة التأهيل.",
  "No created leads in this batch yet": "لسه مفيش ليدات متسجلة في الدفعة دي",
  "Bulk handoff uses Current Interest. Sales employees are filtered by active course assignments only.": "التسليم الجماعي بيستخدم الاهتمام الحالي. موظفو السيلز بيتفلتروا حسب إسنادات الكورسات النشطة بس.",
  "Select Current Interest": "اختار الاهتمام الحالي",
  "Active Sales Employees": "موظفو السيلز النشطون",
  "Select Sales employee assigned to this course": "اختار موظف سيلز مسند للكورس ده",
  "{0} selected qualified leads will be sent together.": "هيتم إرسال {0} ليد مؤهل محدد مع بعض.",
  "Send Mode": "طريقة الإرسال",
  "Send all available qualified leads": "ابعث كل الليدات المؤهلة المتاحة",
  "Send a specific count": "ابعث عدد محدد",
  "No sheet details": "مفيش تفاصيل للشيت",
  "more": "إضافي",
  "Lead sent to sales manager": "الليد اتبعت لمدير المبيعات",
  "Lead moved to currently not interested": "الليد اتنقل لمش مهتم حاليًا",
  "Could not save decision": "مش قادرين نحفظ القرار",
  "Lead released back to sales distribution": "الليد رجع لتوزيع السيلز",
  "Could not release lead": "مش قادرين نرجّع الليد للتوزيع",
  "Sheet Data": "بيانات الشيت",
  "No reason captured": "مفيش سبب مسجل",
  "Tele-sales": "تلي سيلز",
  "at": "الساعة",
  "Write call outcome and customer context...": "اكتب نتيجة المكالمة ومعلومات العميل...",
  "Release": "رجّع للتوزيع",
  "Currently Not Interested": "مش مهتم حاليًا",
  "Tele-sales Review Queue": "قائمة مراجعة التلي سيلز",
  "Manual import only": "استيراد يدوي بس",
  "Could not load tele-sales leads": "مش قادرين نحمّل ليدات التلي سيلز",
  "No rejected manual leads": "مفيش ليدات يدوية مرفوضة",
  "No pending manual leads": "مفيش ليدات يدوية معلّقة",
  "Alternative Phone / WhatsApp": "تليفون بديل / واتساب",
  "View all →": "اعرض الكل ←",
  "Save failed": "الحفظ فشل",
  "Discovery started": "بدأ البحث عن المصادر",
  "Discovery failed": "البحث عن المصادر فشل",
  "Status update failed": "تحديث الحالة فشل",
  "Distribution settings were not saved": "إعدادات التوزيع مااتحفظتش",
  "Phone field is required. Please select the Sheet column containing the primary phone number.": "حقل التليفون مطلوب. اختار عمود الشيت اللي فيه رقم التليفون الأساسي.",
  "Please select the course assigned to this source.": "اختار الكورس المسند للمصدر ده.",
  "Retry failed": "إعادة المحاولة فشلت",
  "Manual refill failed": "ملء الأماكن يدويًا فشل",
  "Discard unsaved changes?": "تتجاهل التغييرات اللي مااتحفظتش؟",
  "Import Status": "حالة الاستيراد",
  "The last import attempt failed.": "آخر محاولة استيراد فشلت.",
  "Pull Now only": "سحب الآن بس",
  "Import paused": "الاستيراد متوقف مؤقتًا",
  "Manual retry needed": "محتاج إعادة محاولة يدويًا",
  "Distribution Status": "حالة التوزيع",
  "Imported Leads": "الليدات المستوردة",
  "Last Sheet Check": "آخر مراجعة للشيت",
  "Not checked yet": "لسه مااتراجعش",
  "{0} rows processed": "تمت معالجة {0} صف",
  "No new rows": "مفيش صفوف جديدة",
  "Current assigned leads": "الليدات المسندة حاليًا",
  "Sheet row": "صف الشيت",
  "Imported at": "وقت الاستيراد",
  "Assigned sales": "موظف السيلز المسند له",
  "All problems": "كل المشاكل",
  "Source setup": "إعداد المصدر",
  "Pending rows": "صفوف معلّقة",
  "Skipped rows": "صفوف متخطّاة",
  "Failed rows": "صفوف فشلت",
  "Data Management": "إدارة البيانات",
  "Overview and management of all connected data sources.": "نظرة عامة وإدارة كل مصادر البيانات المتصلة.",
  "Discovering...": "بندور على المصادر...",
  "Discover Sources": "ابحث عن المصادر",
  "Data management summary": "ملخص إدارة البيانات",
  "Connected Sources": "المصادر المتصلة",
  "Mapping Issues": "مشاكل ربط الحقول",
  "Distribution Paused": "التوزيع متوقف مؤقتًا",
  "Review source health and open the source that needs attention.": "راجع حالة المصادر وافتح المصدر اللي محتاج تدخل.",
  "Search source...": "ابحث عن مصدر...",
  "Search source": "ابحث عن مصدر",
  "Waiting to retry": "مستني إعادة المحاولة",
  "Mapping Status": "حالة ربط الحقول",
  "Needs Mapping": "محتاج ربط الحقول",
  "Mapping Error": "خطأ في ربط الحقول",
  "Source Type": "نوع المصدر",
  "Advanced filters active": "الفلاتر المتقدمة مفعّلة",
  "All months": "كل الشهور",
  "Data state": "حالة البيانات",
  "All data": "كل البيانات",
  "Has Unassigned Leads": "فيه ليدات من غير موظف",
  "Has Slot Waiting": "فيه ليدات مستنية مكان",
  "Has Duplicates": "فيه بيانات مكررة",
  "Has Invalid Leads": "فيه ليدات غير صالحة",
  "Active filters:": "الفلاتر المفعّلة:",
  "No connected sources yet.": "لسه مفيش مصادر متصلة.",
  "Discovered sheets will appear here after the Google Sheets API discovery task reads your connected spreadsheets.": "الشيتات اللي اتلاقت هتظهر هنا بعد ما مهمة البحث عبر Google Sheets API تقرأ جداولك المتصلة.",
  "No sources match the selected filters.": "مفيش مصادر مطابقة للفلاتر.",
  "Import in progress...": "الاستيراد جاري...",
  "Pull Now": "اسحب الآن",
  "View mapping": "اعرض ربط الحقول",
  "Complete the required mapping before changing distribution state.": "كمّل ربط الحقول المطلوبة قبل ما تغيّر حالة التوزيع.",
  "Resume distribution": "كمّل التوزيع",
  "Pause distribution": "وقّف التوزيع مؤقتًا",
  "Summary": "الملخص",
  "Validation": "التحقق من البيانات",
  "Sheet status": "حالة الشيت",
  "Connection": "الاتصال",
  "Rate limited": "وصل لحد الطلبات المسموح",
  "Connected": "متصل",
  "Disconnected": "غير متصل",
  "Every": "كل",
  "min": "دقيقة",
  "No sheet check yet": "لسه مفيش مراجعة للشيت",
  "Last Distribution": "آخر توزيع",
  "No distribution yet": "لسه مفيش توزيع",
  "{0} leads sent to {1} employees": "تم إرسال {0} ليد لـ {1} موظف",
  "Import waiting for Google Sheets": "الاستيراد مستني Google Sheets",
  "Last import check needs attention": "آخر مراجعة استيراد محتاجة تدخل",
  "Import Statistics": "إحصائيات الاستيراد",
  "Rows processed from this source": "الصفوف اللي اتعالجت من المصدر ده",
  "Valid Leads": "ليدات صالحة",
  "Unique and ready for distribution": "غير مكررة وجاهزة للتوزيع",
  "Duplicates": "بيانات مكررة",
  "Phone number already exists": "رقم التليفون موجود بالفعل",
  "Invalid": "غير صالح",
  "Empty phone or text only": "التليفون فاضي أو فيه نص بس",
  "Distribution Statistics": "إحصائيات التوزيع",
  "Valid leads available to sales": "ليدات صالحة متاحة للسيلز",
  "Valid leads not yet assigned to sales": "ليدات صالحة لسه مااتسندتش للسيلز",
  "Assigned Sales": "موظفو السيلز المسندون",
  "Active employees eligible for this source": "موظفون نشطون مؤهلون للمصدر ده",
  "Performance": "الأداء",
  "Enrolled": "التحق بالكورس",
  "Leads that reached Enrolled": "ليدات وصلت لمرحلة الالتحاق",
  "Enrolled ÷ Distributed": "الملتحقين ÷ الموزّع",
  "CRM Field Mapping": "ربط حقول CRM",
  "Map the columns from this source to the core fields shown to sales.": "اربط أعمدة المصدر بالحقول الأساسية اللي بتظهر للسيلز.",
  "Apply Suggestions": "طبّق الاقتراحات",
  "Branch is not mapped": "الفرع مش مربوط",
  "Map the registration branch so imported leads keep their operational branch. This warning does not pause importing.": "اربط فرع التسجيل علشان الليدات المستوردة تحتفظ بفرعها التشغيلي. التحذير ده مش بيوقف الاستيراد.",
  "CRM Field": "حقل CRM",
  "Source Header (Google Sheet Column)": "عنوان العمود في المصدر (عمود Google Sheet)",
  "Suggestion": "الاقتراح",
  "Sample From Sheet": "عينة من الشيت",
  "Select header": "اختار عنوان العمود",
  "Not mapped": "مش مربوط",
  "No suggestion": "مفيش اقتراح",
  "No sample": "مفيش عينة",
  "Only Phone is required to import leads. Other fields are optional. Changes affect pending and future rows only.": "التليفون بس مطلوب لاستيراد الليدات. باقي الحقول اختيارية. التغييرات بتأثر على الصفوف المعلّقة والجديدة بس.",
  "Course Assignment": "إسناد الكورس",
  "Assign one CRM course to all new leads imported from this source.": "اسند كورس CRM واحد لكل الليدات الجديدة المستوردة من المصدر ده.",
  "Personal Questions & Extra Data": "أسئلة شخصية وبيانات إضافية",
  "Selected:": "المحدد:",
  "Select additional columns to show under Additional Information in lead details.": "اختار أعمدة إضافية تظهر تحت معلومات إضافية في تفاصيل الليد.",
  "Select additional columns": "اختار أعمدة إضافية",
  "Main CRM fields are unavailable here to avoid showing the same information twice.": "حقول CRM الأساسية مش متاحة هنا علشان المعلومة ماتظهرش مرتين.",
  "Missing {0}.": "{0} ناقص.",
  "Save Mapping": "احفظ ربط الحقول",
  "Data issue queue": "قائمة مشاكل البيانات",
  "Handle rows that could not be imported cleanly before they affect distribution or reporting.": "راجع الصفوف اللي مااتستوردتش بشكل سليم قبل ما تأثر على التوزيع أو التقارير.",
  "Fix mapping": "صلّح ربط الحقول",
  "Complete mapping first or wait until problem rows exist.": "كمّل ربط الحقول الأول أو استنى ظهور صفوف فيها مشاكل.",
  "Retry problem rows": "حاول معالجة الصفوف اللي فيها مشاكل تاني",
  "Could not load problem rows": "مش قادرين نحمّل الصفوف اللي فيها مشاكل",
  "Problem row filters": "فلاتر الصفوف اللي فيها مشاكل",
  "Loading latest rows...": "بنحمّل أحدث الصفوف...",
  "Row": "الصف",
  "Contact sample": "عينة بيانات التواصل",
  "Retry row": "حاول معالجة الصف تاني",
  "No bad data in this source": "مفيش بيانات فيها مشاكل في المصدر ده",
  "New rows that fail validation, get skipped, or wait for cleanup will appear here automatically.": "الصفوف الجديدة اللي تفشل في التحقق أو يتم تخطيها أو تستنى تصحيح هتظهر هنا تلقائيًا.",
  "Configure how valid unassigned leads from this source reach your sales team.": "اضبط طريقة وصول الليدات الصالحة اللي من غير موظف من المصدر ده لفريق السيلز.",
  "Distribution status": "حالة التوزيع",
  "New assignments are running": "الإسنادات الجديدة شغالة",
  "New leads remain unassigned": "الليدات الجديدة بتفضل من غير موظف",
  "Mode": "الوضع",
  "Automatic": "تلقائي",
  "Manual send is an override": "الإرسال اليدوي بيتجاوز التوزيع التلقائي",
  "Strategy": "طريقة التوزيع",
  "Balanced Round Robin": "تناوب متوازن",
  "Least-loaded eligible employee first": "الموظف المؤهل الأقل حمولة الأول",
  "Updates only after a real assignment": "بيتحدّث بعد إسناد فعلي بس",
  "1. Distribution Settings": "1. إعدادات التوزيع",
  "Every active salesperson has 30 continuous New slots. Each freed slot is refilled automatically from Waiting.": "كل موظف سيلز نشط عنده 30 مكان ثابت لليدات الجديدة. أي مكان يفضى بيتملي تلقائيًا من الانتظار.",
  "New Lead Capacity": "سعة الليدات الجديدة",
  "fixed slots": "أماكن ثابتة",
  "Visible New leads per employee. Waiting leads stay hidden until a slot becomes free.": "الليدات الجديدة الظاهرة لكل موظف. الليدات المنتظرة بتفضل مخفية لحد ما مكان يفضى.",
  "Sales Routing Pool": "مجموعة توجيه السيلز",
  "Edit Pool": "عدّل المجموعة",
  "Select employees assigned to this source course": "اختار موظفين مسندين لكورس المصدر ده",
  "No active eligible employee is available.": "مفيش موظف نشط مؤهل متاح.",
  "No employee will receive automatic leads until you add the pool.": "مفيش موظف هيستلم ليدات تلقائيًا لحد ما تضيف مجموعة التوجيه.",
  "The pool narrows this source; every member must stay actively assigned to the source course.": "المجموعة بتحدد مستلمي المصدر ده؛ وكل عضو لازم يفضل مسند بشكل نشط لكورس المصدر.",
  "Balanced Automatic Distribution": "توزيع تلقائي متوازن",
  "Active eligible employees only": "الموظفون النشطون المؤهلون بس",
  "Employees with more free slots are filled first": "الموظفون اللي عندهم أماكن فاضية أكتر بيستلموا الأول",
  "Equal loads rotate evenly between employees": "عند تساوي الحمولة، التوزيع بيتناوب بالتساوي بين الموظفين",
  "Course performance remains available in the table for coaching and reporting.": "أداء الكورس بيفضل متاح في الجدول للتوجيه والتقارير.",
  "2. Sales Routing & Manual Distribution": "2. توجيه السيلز والتوزيع اليدوي",
  "Queue load is balanced for this source; course performance is shown for reporting.": "حمولة قائمة الانتظار متوازنة للمصدر ده؛ وأداء الكورس ظاهر للتقارير.",
  "valid unassigned leads available": "ليد صالح من غير موظف متاح",
  "Could not load sales distribution": "مش قادرين نحمّل توزيع السيلز",
  "Sales Employee": "موظف السيلز",
  "Visible New": "الليدات الجديدة الظاهرة",
  "Slots Used": "الأماكن المستخدمة",
  "Slot Waiting": "مستني مكان",
  "Course Conversion Rate": "نسبة التحويل للكورس",
  "Avg. Time to Enroll": "متوسط وقت الالتحاق",
  "Performance Score": "درجة الأداء",
  "Last Activity": "آخر نشاط",
  "Manual Send Leads": "إرسال الليدات يدويًا",
  "Sales agent": "موظف السيلز",
  "free slots": "أماكن فاضية",
  "enrolled / handled": "التحق / تمت متابعته",
  "Learning": "في مرحلة التعلم",
  "Send leads": "ابعث الليدات",
  "No eligible routing pool yet": "لسه مفيش مجموعة توجيه مؤهلة",
  "Add active sales employees to the routing pool to start automatic distribution.": "ضيف موظفي سيلز نشطين لمجموعة التوجيه علشان يبدأ التوزيع التلقائي.",
  "Could not load source rows": "مش قادرين نحمّل صفوف المصدر",
  "No rows in this source view": "مفيش صفوف في عرض المصدر ده",
};

export const operationsEnglishTranslations: Record<string, string> = {
  "مخزن الليدات متاح لمدير المبيعات والإدارة العليا فقط.": "Lead Pool is available to Sales Managers and Upper Management only.",
  "مخزن الليدات": "Lead Pool",
  "اسحب الليدات من موظف، ثم وزّعها يدويًا مع الاحتفاظ ببياناتها وتاريخها.": "Withdraw leads from an employee, then distribute them manually while preserving their data and history.",
  "السحب يغيّر الإسناد • تنزيل الملف لا يسحب الليد": "Withdrawal changes assignment • Downloading a file does not withdraw the lead",
  "أقسام مخزن الليدات": "Lead Pool sections",
  "اختر موظفًا ثم حدد ليدات أو اسحب كل ليداته، في أي وقت ودون شرط ٦٠ يومًا.": "Choose an employee, then select leads or withdraw all their leads at any time, with no 60-day minimum.",
  "هذه الليدات بلا موظف حالي، ولن يعيد التوزيع التلقائي إسنادها قبل توزيعك اليدوي.": "These leads have no current employee. Automatic distribution will not assign them before you distribute them manually.",
  "من سحب الليد، وممن سُحب، ولمن وُزع، والتوقيت وسبب كل عملية.": "Who withdrew each lead, its previous and new employees, and the time and reason for every operation.",
  "تحديث": "Refresh",
  "موظف السيلز": "Sales employee",
  "اختر موظفًا": "Choose an employee",
  "(غير نشط)": "(Inactive)",
  "بحث في الليدات": "Search leads",
  "الاسم أو الهاتف أو رقم الليد": "Name, phone, or lead ID",
  "سحب كل ليدات الموظف": "Withdraw all employee leads",
  "يشمل كل ليدات الموظف عبر جميع الصفحات، وليس نتائج البحث فقط. العدد النهائي يظهر في المعاينة.": "Includes all the employee's leads across every page, beyond search results. The final count appears in the preview.",
  "تعذر تحميل الموظفين.": "Could not load employees.",
  "تعذر تحميل القائمة": "Could not load the list",
  "اختر الموظف لعرض ليداته.": "Choose an employee to view their leads.",
  "جارٍ تحميل الليدات…": "Loading leads…",
  "الليد": "Lead",
  "السحب": "Withdrawal",
  "سبب السحب": "Withdrawal reason",
  "التوزيع": "Distribution",
  "سبب التوزيع": "Distribution reason",
  "متاح للتوزيع": "Available for distribution",
  "تم التوزيع": "Distributed",
  "من:": "From:",
  "بواسطة:": "By:",
  "إلى:": "To:",
  "لا توجد عمليات سحب أو توزيع حتى الآن.": "No withdrawals or distributions yet.",
  "لا توجد ليدات مطابقة.": "No matching leads.",
  "تحديد الصفحة الحالية": "Select current page",
  "الهاتف": "Phone",
  "المتابعة القادمة": "Next follow-up",
  "تحديد الليد {0}": "Select lead {0}",
  "{0}–{1} من {2}": "{0}–{1} of {2}",
  "0 ليد": "0 leads",
  "سحب إلى المخزن": "Withdraw to pool",
  "توزيع الليدات المحددة": "Distribute selected leads",
  "كل ليدات الموظف": "All employee leads",
  "{0} ليد محدد عبر الصفحات": "{0} leads selected across pages",
  "الموظفون المستلمون": "Receiving employees",
  "اختر موظفًا واحدًا أو أكثر. تُوزّع الليدات بالتساوي بالتناوب.": "Choose one or more employees. Leads are distributed equally in turn.",
  "توزيع إلى {0}": "Distribute to {0}",
  "لا يوجد موظفو سيلز متاحون للاستلام.": "No Sales employees are available to receive leads.",
  "رقم الليد وملاحظاته وتاريخ التواصل وبيانات الحجز والدفع والفواتير تظل كما هي.": "The lead ID, notes, contact history, booking, payment, and invoice data stay unchanged.",
  "جارٍ التنفيذ…": "Processing…",
  "معاينة السحب": "Preview Withdrawal",
  "معاينة التوزيع": "Preview Distribution",
  "تأكيد سحب الليدات": "Confirm lead withdrawal",
  "تأكيد توزيع الليدات": "Confirm lead distribution",
  "سيتم سحب {0} ليد": "{0} leads will be withdrawn",
  "سيتم توزيع {0} ليد": "{0} leads will be distributed",
  "ستختفي من قائمة عمل الموظف ومتابعاته وتصبح متاحة في المخزن.": "They will leave the employee's work list and follow-ups and become available in the pool.",
  "ستخرج من قائمة المتاح وتظهر لدى الموظفين الجدد.": "They will leave the available list and appear for the new employees.",
  "سبب العملية": "Operation reason",
  "اكتب سبب السحب أو التوزيع": "Enter the reason for withdrawal or distribution",
  "تأكيد السحب": "Confirm withdrawal",
  "تأكيد التوزيع": "Confirm distribution",
  "سجلات التصدير القديمة محفوظة للرجوع إليها. ليست متاحة للتوزيع، ولا يتغير موظفها الحالي.": "Previous export records are saved for reference. They are unavailable for distribution, and their current employee stays unchanged.",
};
